// extracted by mini-css-extract-plugin
export const container = "get-the-app-module--container--2ee0Q";
export const section = "get-the-app-module--section--3rcRz";
export const logosContainer = "get-the-app-module--logos-container--1FQzb";
export const appStore = "get-the-app-module--app-store--2ksHH";
export const whatsNew = "get-the-app-module--whats-new--u0iue";
export const featureList = "get-the-app-module--feature-list--3us_4";
export const subTitle = "get-the-app-module--sub-title--j3wMH";
export const cards = "get-the-app-module--cards--VPLLB";